import { render } from "./ForgetPassword.vue?vue&type=template&id=ed9fda60&scoped=true"
import script from "./ForgetPassword.vue?vue&type=script&lang=js"
export * from "./ForgetPassword.vue?vue&type=script&lang=js"

import "./ForgetPassword.vue?vue&type=style&index=0&id=ed9fda60&lang=scss&scoped=true"

import exportComponent from "D:\\QYYY\\mall_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed9fda60"]])

export default __exports__